export default "__VITE_ASSET__DLcZMhTP__"